export enum LS {
  Authenticated = "authenticated",
  AuthProvider = "auth_provider",
  AmazonOnboardingStatus = "amazon_onboarding_status",
}
